import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
const ReportIcon: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><path d="M23.25 3.75H0.75V20.25H23.25V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="bevel" /><path d="M7.5 15.75C9.57107 15.75 11.25 14.0711 11.25 12C11.25 9.92893 9.57107 8.25 7.5 8.25C5.42893 8.25 3.75 9.92893 3.75 12C3.75 14.0711 5.42893 15.75 7.5 15.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="bevel" /><path d="M7.5 8.25V12H11.25" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" /><path d="M15 9H21" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="bevel" /><path d="M15 12H21" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="bevel" /><path d="M15 15H21" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="bevel" /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default ReportIcon;